<template>
    <div class="calendar" ref="calendars">
        <form name="CLD">
            <table id="calendarTable">
                <tr>
                    <td colspan="7" id="yearAndMonthTd">
                        <select name="SY" id="yearSelect" v-model="y">
                            <option v-for="(v,k,i) in date_range" :value="k" :key="i">{{k}}</option>
                        </select>年
                        <select name="SM" id="monthSelect" v-model="m">
                            <option v-for="(v,i) in data_month_range" :value="v" :key="i">{{v}}</option>
                        </select>月
                    </td>
                </tr>
                <tr align=middle>
                    <td class="weekTitle" v-for="(week,index) in weeks" :key="index">{{week}}</td>
                </tr>
                <tr v-for="(i,trIndex) in 6" :key="trIndex" align=middle>
                    <td v-for="(j,tdIndex) in 7" :key="tdIndex" class="calendar_td" :id="gernerateId(7*trIndex+j)" :class="{tdBgcolor: !oneMonthDate[7*trIndex+j-1] , beSelectedTd: oneMonthTimestamp[7*trIndex+j-1]==beSelectedTimestamp , tdBgcolorBlack: oneMonthTimestamp[7*trIndex+j-1]&&oneMonthTimestamp[7*trIndex+j-1]<todayTimestamp || oneMonthTimestamp[7*trIndex+j-1]==todayTimestamp&&nowAndNowTimestamp>todayStopSellTimestamp || oneMonthDate[7*trIndex+j-1]&&!goodsPriceAndStoreCount[7*trIndex+j-1].store_count_remainder || oneMonthDate[7*trIndex+j-1]&&!goodsPriceAndStoreCount[7*trIndex+j-1].is_sell }" @click="chooseDateFunc(oneMonthDate[7*trIndex+j-1],oneMonthTimestamp[7*trIndex+j-1],goodsPriceAndStoreCount[7*trIndex+j-1].is_sell,goodsPriceAndStoreCount[7*trIndex+j-1].store_count_remainder,goodsPriceAndStoreCount[7*trIndex+j-1].date,7*trIndex+j-1,goodsPriceAndStoreCount[7*trIndex+j-1].price)">
                    <!-- <td v-for="(j,tdIndex) in 7" :key="tdIndex" class="calendar_td" :id="gernerateId(7*trIndex+j)"> -->
                        <span class="dateItem">{{oneMonthDate[7*trIndex+j-1]}}</span>
                        <br>
                        <span class="storeItem">{{showStoreCount(goodsPriceAndStoreCount[7*trIndex+j-1].store_count_remainder,goodsPriceAndStoreCount[7*trIndex+j-1].is_sell,7*trIndex+j-1)}}</span>
                        <br>
                        <span class="priceItem">{{showPrice(goodsPriceAndStoreCount[7*trIndex+j-1].price,goodsPriceAndStoreCount[7*trIndex+j-1].is_sell,7*trIndex+j-1,goodsPriceAndStoreCount[7*trIndex+j-1].store_count_remainder)}}</span>
                    </td>
                </tr>
            </table>
        </form>
        <div class="confirm" @click="confirmFunc()">确认</div>
    </div>
</template>

<script>
import { Toast } from 'mint-ui';
export default {
    name:"calendar2",
    props:["goods_id","date_range","ajax_date_range","todayStopSellTime"],
    data:function () {
        return {
            weeks:["日","一","二","三","四","五","六"],
            solarMonth: new Array(31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31),
            calendar:"",
            data_month_range:"",
            y:this.getYear(),
            m:this.getMonth(),
            now_year:new Date().getFullYear(),
            now_month:new Date().getMonth() + 1,
            oneMonthDate:"",
            oneMonthTimestamp:"",
            oneMonthBeSelected:"",
            // goodsPriceAndStoreCount:[],
            goodsPriceAndStoreCount:this.setUpInitArr(),
            // goodsPriceAndStoreCount:this.bbb,
            todayTimestamp:this.getToday(),          //今天的时间戳
            userChooseTimestamp:this.getToday(),     //用户选择日期的时间戳，默认是当天的时间戳
            userChooseDate:this.getNowFormatDateTwo(),       //用户选择的日期，默认是当天的日期
            todayStopSellTimestamp:this.getTodayStopSellTimeFunc(),          //该商品当天购买的截至时间戳
            nowAndNowTimestamp:(new Date()).getTime()/1000,             //此时此刻的时间戳
            beSelectedIndex:66,           //被选中的索引
            // beSelectedTimestamp:this.getTodayBeSelectedTimestamp(),
            beSelectedTimestamp:1,
        }
    },
    created: function () {
        this.init_month_range();
        this.drawCld(this.y,this.m);
    },
    mounted: function () {
        this.$refs.calendars.addEventListener('touchmove',(e) => {
            e.stopPropagation();
            e.preventDefault();
        })
    },
    watch: {
        m: function (n,o){
            this.drawCld(this.y,this.m);
        },
        y: function (n,o) {
            this.data_month_range = this.date_range[n];
            let index = this.data_month_range.indexOf(this.m);
            if(index == -1){
                this.m = this.data_month_range[0];
            }
            this.drawCld(this.y,this.m);
        }
    },
    methods: {
        // 创建42个元素的数组
        setUpInitArr: function () {
            let arr = [];
            let obj = {
                date:"",
                day:0,
                is_edited:false,
                is_holiday:false,
                is_sell:0,
                price:"",
                price_from:0,
                store_count:0,
                store_count_from:0,
                store_count_remainder:0
            }
            for(var i = 0;i < 42;i++){
                arr.push(obj);
            }
            return arr;
        },
        // 确认的点击方法
        confirmFunc: function () {
            this.$emit("changeShowCalendarStatus",false);
        },
        // 当天是否是选中日期的时间戳
        getTodayBeSelectedTimestamp: function () {
            let nowAndNowTimestamp = new Date();
            nowAndNowTimestamp = nowAndNowTimestamp.getTime()/1000;
            let todayStopSellTimestamp = this.getTodayStopSellTimeFunc();
            if(nowAndNowTimestamp > todayStopSellTimestamp){
                return 1;
            }else{
                return this.getToday();
            }
        },
        // 当天截至购买时间
        getTodayStopSellTimeFunc: function () {
            let todayStopSellDate = this.getNowFormatDate();
            let todayStopSellTimestamp = new Date((todayStopSellDate + " " + this.todayStopSellTime).replace(/-/g,'/')).getTime()/1000;
            return todayStopSellTimestamp;
        },
        // 点击日历上的日期
        chooseDateFunc: function (chooseDay,chooseTimestamp,is_sell,store_count_remainder,chooseDate,index,price) {
            if(!chooseDay){
                return false;
            }
            if(chooseTimestamp < this.todayTimestamp){
                Toast("不可选择以往日期");
                return false;
            }
            if(chooseTimestamp == this.todayTimestamp && this.nowAndNowTimestamp > this.todayStopSellTimestamp){
                Toast("商品已超过当天售卖时间");
                return false;
            }
            if(!is_sell){
                Toast("该日期内商品不可售");
                return false;
            }
            if(!store_count_remainder){
                Toast("该商品没有库存");
                return false;
            }
            this.beSelectedIndex = index;
            this.beSelectedTimestamp = this.oneMonthTimestamp[index];
            this.userChooseTimestamp = chooseTimestamp;
            this.userChooseDate = chooseDate;
            this.$emit("userChooseDate",chooseDate);
            this.$emit("userChoosePrice",price);
        },
        cldConstruction: function (y,m) {
            var calendar = {};
            calendar.length = this.solarDays(y,m);
            var sDObj = new Date(y,m,1);     //当月第一天的日期
            calendar.firstWeek = sDObj.getDay();      //公历当月1日星期几
            var now_date = new Date();
            for(var i = 0;i < calendar.length;i++){
                var calElement = {};
                if(now_date.getDate() == i+1){
                    calElement.isToday = true;
                }else{
                    calElement.isToday = false;
                }
                calElement.week = this.weeks[(i + calendar.firstWeek) % 7];
                calElement.weekNum = (i + calendar.firstWeek) % 7;
                calElement.sYear = y;
                calElement.sMonth = m + 1;
                calElement.sDay = i + 1;
                calendar[i] = calElement;
            }
            this.calendar = calendar;
            var oneMonthDate = [];
            var oneMonthTimestamp = [];
            var oneMonthBeSelected = [];
            for(var i = 0;i < 42;i++){
                let w = "";
                if(i < calendar[0].weekNum){
                    oneMonthDate.push(w);
                    oneMonthTimestamp.push(w);
                    oneMonthBeSelected.push(w);
                }else{
                    if(i-calendar[0].weekNum < calendar.length){
                        let cldObj = calendar[i-calendar[0].weekNum];
                        oneMonthDate.push(cldObj.sDay);
                        // 将本月的时间转化为时间戳
                        // let d = cldObj.sYear + "/" + cldObj.sMonth + "/" + cldObj.sDay + " 00:00:00.0";
                        let d = cldObj.sYear + "/" + cldObj.sMonth + "/" + cldObj.sDay;
                        let timestamp = new Date(d);
                        timestamp = timestamp.getTime()/1000;
                        oneMonthTimestamp.push(timestamp);
                        // 设置被选中状态数组
                        if(timestamp == this.todayTimestamp){
                            var t = new Date();
                            var tp = t.getTime()/1000;
                            if(t > this.todayStopSellTimestamp){
                                oneMonthBeSelected.push(false);
                            }else{
                                oneMonthBeSelected.push(true);
                            }
                        }else{
                            oneMonthBeSelected.push(false);
                        }
                    }else{
                        oneMonthDate.push(w);
                        oneMonthTimestamp.push(w);
                        oneMonthBeSelected.push(w);
                    }
                }
            }
            this.oneMonthDate = oneMonthDate;
            this.oneMonthTimestamp = oneMonthTimestamp;
            this.oneMonthBeSelected = oneMonthBeSelected;
        },
        // 返回公历y年m+1月的天数
        solarDays: function (y,m) {
            if (m == 1)
                return (((y % 4 == 0) && (y % 100 != 0) || (y % 400 == 0)) ? 29 : 28);
            else
                return this.solarMonth[m];
        },
        showStoreCount: function (count,is_sell,index) {
            if(this.oneMonthDate[index]){
                if(this.oneMonthTimestamp[index] > this.todayTimestamp){
                    if(is_sell){
                        // return "余" + count + "件";
                        if(count == 0){
                            return "";
                        }else{
                            return "余" + count + "件";
                        }
                    }else{
                        return "";
                    }
                }else if(this.oneMonthTimestamp[index] == this.todayTimestamp){
                    if(is_sell){
                        let currentTime = new Date();
                        let currentTimestamp = currentTime.getTime()/1000;
                        if(currentTimestamp > this.todayStopSellTimestamp){
                            return "";
                        }else{
                            // return "余" + count + "件";
                            if(count == 0){
                                return "";
                            }else{
                                return "余" + count + "件";
                            }
                        }
                    }else{
                        return "";
                    }
                }else{
                    return "";
                }
            }else{
                return "";
            }
        },
        showPrice: function (price,is_sell,index,count) {
            if(this.oneMonthDate[index]){
                if(this.oneMonthTimestamp[index] > this.todayTimestamp){
                    if(is_sell){
                        // return price;
                        if(count == 0){
                            return "";
                        }else{
                            return price;
                        }
                    }else{
                        return "";
                    }
                }else if(this.oneMonthTimestamp[index] == this.todayTimestamp){
                    if(is_sell){
                        let currentTime = new Date();
                        let currentTimestamp = currentTime.getTime()/1000;
                        if(currentTimestamp > this.todayStopSellTimestamp){
                            return "";
                        }else{
                            // return price;
                            if(count == 0){
                                return "";
                            }else{
                                return price;
                            }
                        }
                    }else{
                        return "";
                    }
                }else{
                    return "";
                }
            }else{
                return "";
            }
        },
        getToday: function () {
            let todayDate = this.getNowFormatDate();
            // let todayTimestamp = new Date((todayDate + " 00:00:00.0").replace(/-/g,'/')).getTime()/1000;
            let todayTimestamp = new Date(todayDate.replace(/-/g,'/')).getTime()/1000;
            return todayTimestamp;
        },
        getNowFormatDate: function () {
            var date = new Date();
            var seperator1 = "-";
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            var currentdate = year + seperator1 + month + seperator1 + strDate;
            return currentdate;
        },
        getNowFormatDateTwo: function () {
            var date = new Date();
            var seperator1 = "-";
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = strDate;
            }
            var currentdate = year + seperator1 + month + seperator1 + strDate;
            return currentdate;
        },
        drawCld:function (SY, SM) {
            var y = parseInt(SY);
            var m = parseInt(SM)-1;
            this.cldConstruction(y,m);
            this.getGoodsPriceAndStoreCount(y,m);
        },
        // 获取商品的价格和库存
        getGoodsPriceAndStoreCount: function (y,m) {
            this.$http({
                xhrFields: {
                    withCredentials: true
                },
                crossDomain: true,
                method: "post",
                url: this.weburl + this.hurl + "/goods/ajax_get_order_goods_price_store",
                dataType: "json",
                data: {
                    goods_id: this.goods_id,
                    year:y,
                    month:m+1
                }
            })
            .then(res => {
                if(res.data.status == 1){
                    this.goodsPriceAndStoreCount = [];
                    var arr = res.data.data.datas;
                    for(var i = 0;i < 42;i++){
                        let obj = {
                            date:"",
                            day:0,
                            is_edited:false,
                            is_holiday:false,
                            is_sell:0,
                            price:"",
                            price_from:0,
                            store_count:0,
                            store_count_from:0,
                            store_count_remainder:0
                        };
                        if(i < this.calendar[0].weekNum){
                            this.goodsPriceAndStoreCount.push(obj);
                        }else{
                            if(i-this.calendar[0].weekNum < this.calendar.length){
                                this.goodsPriceAndStoreCount.push(arr[i-this.calendar[0].weekNum]);
                            }else{
                                this.goodsPriceAndStoreCount.push(obj);
                            }
                        }
                    }
                }
            })
            .catch(err => {
                console.log(err);
            })
        },
        gernerateId: function (id) {
            return "GD" + id;
        },
        getYear: function () {
            var flag = "";
            for(var i = this.ajax_date_range.year_start; i <= this.ajax_date_range.year_stop;i++){
                if(this.now_year == i){
                    flag = i
                }
            }
            if(flag){
                return flag;
            }else{
                for(var i in this.date_range){
                    if(i == this.ajax_date_range.year_start){
                        flag = i;
                    }
                }
                return flag;
            }
        },
        getMonth: function () {
            // return this.date_range[this.ajax_date_range.year_start][0];
            let current_year = new Date().getFullYear();
            let current_month = new Date().getMonth() + 1;
            let arr = [];
            let current_month_range = this.date_range[current_year];
            for(var i = 0;i < current_month_range.length;i++){
                if(current_month_range[i] == current_month){
                    arr.push(current_month);
                }else if(current_month_range[i] > current_month){
                    arr.push(current_month_range[i]);
                }
            }
            return arr[0];
        },
        // 默认进来选择的就是当年的月份
        init_month_range: function () {
            // this.data_month_range = this.date_range[this.now_year];
            let current_month = new Date().getMonth() + 1;
            let arr = [];
            let current_month_range = this.date_range[this.now_year];
            for(var i = 0;i < current_month_range.length;i++){
                if(current_month_range[i] == current_month){
                    arr.push(current_month);
                }else if(current_month_range[i] > current_month){
                    arr.push(current_month_range[i]);
                }
            }
            this.data_month_range = arr;
        },
        // 获取商品开卖的时间，年与月
        getCanSellDate: function () {
            this.$http({
                xhrFields: {
                    withCredentials: true
                },
                crossDomain: true,
                method: "post",
                url: this.weburl + this.hurl + "/Goods/get_goods_is_sell",
                dataType: "json",
                data: {
                    goods_id: this.goods_id        //商品id：goods_id
                }
            })
            .then(res => {
                var year_start = res.data.result.year_start;
                var year_stop = res.data.result.year_stop;
                var month_start = res.data.result.month_start;
                var month_stop = res.data.result.mouth_stop;
                this.create_date_month(year_start, month_start, year_stop, month_stop);
            })
            .catch(err => {
                console.log(err);
            })
        },
        create_date_month: function (year_start, month_start, year_stop, month_stop) {
            for (var i = year_start; i <= year_stop; i++) {
                var month_range = [];
                if (year_start == year_stop) {
                    for (var j = month_start; j <= month_stop; j++) {
                        month_range.push(j);
                    }
                    this.date_range[i] = month_range;
                } else {
                    if (i == year_start) {
                        for (var j = month_start; j <= 12; j++) {
                            month_range.push(j);
                        }
                        this.date_range[i] = month_range;
                    } else if (i == year_stop) {
                        for (var j = 1; j <= month_stop; j++) {
                            month_range.push(j);
                        }
                        this.date_range[i] = month_range;
                    } else {
                        for (var j = 1; j <= 12; j++) {
                            month_range.push(j);
                        }
                        this.date_range[i] = month_range;
                    }
                }
            }
        }
    },
    computed:{
        weburl: function () {
            return this.$store.state.weburl;
        },
        hurl: function () {
            return this.$store.state.hurl;
        }
    }
}
</script>

<style scoped>
.calendar{
    width: 100vw;
    /* height: 73vh; */
    background-color: white;
    position: fixed;
    bottom: 0px;
    z-index: 102;
    left: 0;
}
table,
table tr th,
table tr td {
    border: 1px solid #ccc;
    cursor: pointer;
}
#calendarTable{
    width: 100%;
}
#yearAndMonthTd{
    padding: 5px 0;
    background-color: #d3cac8;
    font-weight: 700;
    color: #6d3347;
    text-align: center;
}
#yearSelect{
    width: 100px;
    height: 30px;
    border-radius: 5px;
    position: relative;
}
#monthSelect{
    width: 100px;
    height: 30px;
    border-radius: 5px;
}
.weekTitle{
    height: 40px;
    line-height: 40px;
    background-color: #722528;
    color: white;
}
.calendar_td{
    height: 56px;
    width:calc(100% / 7);
}
.dateItem{
    display: inline-block;
    margin-top: 5px;
}
.storeItem{
    display: inline-block;
    font-size: 12px;
}
.priceItem{
    display: inline-block;
    color: #f39340;
    font-size: 13px;
}
.tdBgcolor{
    background-color: #f4f4f4;
}
.tdBgcolorBlack{
    background-color: #cbcbcb;
}
.beSelectedTd{
    background-color: pink;
}
.confirm{
    height: 45px;
    width: 60%;
    background-color: #f27605;
    margin: 5px auto;
    border-radius: 10px;
    line-height: 45px;
    text-align: center;
    font-size: 26px;
    font-weight: 560;
    letter-spacing: 5px;
    color: white;
}
</style>
